import { render, staticRenderFns } from "./VolunteerStandardFindResult.vue?vue&type=template&id=06a12be9&scoped=true"
import script from "./VolunteerStandardFindResult.vue?vue&type=script&lang=ts"
export * from "./VolunteerStandardFindResult.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerStandardFindResult.vue?vue&type=style&index=0&id=06a12be9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a12be9",
  null
  
)

export default component.exports